import styled from "styled-components";
import brazilFlag from "./../../../assets/images/brazil-color.png";

const bp = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
};

export const WrapperSearchVehicleDecoder = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #f9f9f9;

  header {
    width: 100%;
    height: 70px;
    background-color: #656565;

    img {
      width: 100px;
      margin: 12px 72px;

      @media (max-width: ${bp.md}) {
        margin: 12px 24px;
        width: 90px;
      }
    }
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
`;

export const LogoutButton = styled.button`
  cursor: pointer;
  text-decoration: none;
  border: none;
  background-color: transparent;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border-radius: 6px;
  padding: 10px 25px;

  font-family: ${(props) => props.theme.fontFamily.Montserrat};
  font-size: 18px;
  font-weight: 700;

  color: #fff;

  transition: background-color 0.2s ease, transform 0.1s ease;

  &:hover {
    color: #e9bf63;
  }

  &:active {
    transform: translateY(1px);
    color: #e9bf63;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const ContainerSearchVehicle = styled.div`
  width: 100%;
  max-width: 1140px;
  margin: 32px auto 24px;
  padding: 0 32px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: ${bp.lg}) {
    padding: 0 24px;
  }
  @media (max-width: ${bp.md}) {
    padding: 0 16px;
    gap: 20px;
  }
`;

export const TitleSearch = styled.div`
  font-family: ${(props) => props.theme.fontFamily.Montserrat};
  font-size: 20px;
  font-weight: 700;
  color: #313333;
  line-height: 24px;

  @media (max-width: ${bp.md}) {
    font-size: 18px;
    line-height: 22px;
  }
`;

export const BoxSearch = styled.div`
  background-color: #edededff;
  width: 100%;
  min-height: 140px;
  display: flex;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  padding: 20px 32px;

  justify-content: flex-start;

  @media (max-width: ${bp.md}) {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    padding: 16px;
    min-height: auto;

    > span {
      display: block;
      width: 100%;
      text-align: center;
      font-weight: 600;
      color: #6b7280;
    }

    > div {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;

export const PlateInputWrapper = styled.div`
  width: 200px;
  border: 2px solid #ccc;
  border-radius: 14px;
  overflow: hidden;
  font-family: Arial, sans-serif;

  @media (max-width: ${bp.md}) {
    width: 80%;
    max-width: 360px;
  }
`;

export const PlateTop = styled.div`
  background-color: #002776;
  color: white;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 13px;
`;

export const FlagBrazil = styled.span`
  padding: 0 50px;
  font-weight: bold;
  font-family: ${(props) => props.theme.fontFamily.Montserrat};

  @media (max-width: ${bp.md}) {
    padding: 0 24px;
  }
`;

export const Flag = styled.span`
  width: 17px;
  height: 14px;
  background-image: url(${brazilFlag});
  background-size: cover;
  padding-top: 16px;
`;

export const PlateBottom = styled.div`
  background-color: white;
`;

export const PlateInput = styled.input<
  React.InputHTMLAttributes<HTMLInputElement>
>`
  width: 100%;
  border: none;
  font-size: 16px;
  color: #333;
  text-align: center;
  padding: 10px 12px;

  &::placeholder {
    color: #aaa;
    text-align: center;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.6;
    background: #e5e5e5;
    cursor: not-allowed;
  }
`;

export const VinFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: ${bp.md}) {
    align-items: center;
  }
`;

export const VinInput = styled.input`
  width: 100%;
  height: 56px;
  padding: 0 16px;

  background: #ffffff;
  color: #111827;
  border: 2px solid #d1d5db;
  border-radius: 10px;

  font-size: 18px;
  line-height: 24px;
  font-weight: 400;

  ::placeholder {
    color: #9ca3af;
  }

  &:hover {
    border-color: #c7cdd4;
  }

  &:focus {
    outline: 3px solid rgba(59, 130, 246, 0.25);
    outline-offset: 2px;
    border-color: #9ca3af;
  }

  &:disabled {
    opacity: 0.6;
    background: #e5e5e5;
    cursor: not-allowed;
  }

  @media (max-width: ${bp.md}) {
    max-width: 360px;
  }
`;

export const ConsultButton = styled.button`
  height: 40px;
  padding: 0 24px;
  min-width: 220px;

  border-radius: 9999px;
  border: none;

  background: #e9bf63;
  color: #1f3b6e;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;

  cursor: pointer;
  transition: background-color 160ms ease, transform 120ms ease,
    box-shadow 160ms ease;

  &:hover:enabled {
    background: #e4b750;
  }

  &:active:enabled {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 3px solid rgba(31, 59, 110, 0.35);
    outline-offset: 3px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #e5e5e5;
  }

  @media (max-width: ${bp.md}) {
    width: 100%;
    max-width: 360px;
    align-self: center;
  }
`;

export const ContainerResultVehicleDecoder = styled.div`
  width: 100%;
  max-width: 1140px;
  margin: 0 auto 64px;
  padding: 23px 32px;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: min-content;
  gap: 16px 20px;

  @media (max-width: ${bp.xl}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${bp.md}) {
    grid-template-columns: 1fr;
    padding: 16px;
    gap: 12px;
  }
`;

export const Field = styled.div<{ span?: number }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  grid-column: span ${({ span }) => span || 1};

  @media (max-width: ${bp.md}) {
    grid-column: span 1;
  }
`;

export const FieldLabel = styled.label`
  font-family: ${(props) =>
    props.theme?.fontFamily?.Montserrat || "Montserrat, Arial, sans-serif"};
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
`;

export const FieldInput = styled.input`
  width: 100%;
  height: 56px;
  padding: 0 16px;

  background: #ffffff;
  color: #111827;
  border: 2px solid #d1d5db;
  border-radius: 16px;

  font-size: 16px;
  line-height: 24px;
  font-weight: 400;

  ::placeholder {
    color: #9ca3af;
  }

  &:hover {
    border-color: #c7cdd4;
  }
  &:focus {
    outline: 3px solid rgba(59, 130, 246, 0.25);
    outline-offset: 2px;
    border-color: #9ca3af;
  }

  &[readonly] {
    background-color: #f5f5f5;
    opacity: 0.75;
    cursor: not-allowed;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: #e5e5e5;
  }
`;

export const FieldInputWithIcon = styled(FieldInput)`
  padding-right: 44px;
`;

export const RightIcon = styled.span`
  position: absolute;
  right: 12px;
  height: 20px;
  width: 20px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  color: #6b7280;
  pointer-events: none;
`;

export const ActionsRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;

  @media (max-width: ${bp.md}) {
    grid-column: 1 / -1;
    margin-top: 4px;
  }
`;

export const Divider = styled.hr`
  grid-column: 1 / -1;
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 8px 0;
`;
